import { updatePropertyIcons } from '../layers';
import { rememberPropertyClick } from '../storage';
import Logger from '../../logging/logger';
import { captureException } from '../../logging/sentry';

const handlePropertyLayerClick = async ( ctx, event ) => {
    const { feature } = event.detail;

    Logger.info( '[map] Map Property Feature Click', feature );

    const property = ctx.properties.get( feature.properties.id );

    if ( !property ) {
        return;
    }

    ctx.properties.forEach( ( property ) => {
        property.active = false;
    } );

    rememberPropertyClick( property.id );

    const availableWidth = window.screen.availWidth;
    const openPropertyDetails = ( process.env.MAP_SEARCH_OPEN_PROPERTY_DETAILS && process.env.MAP_SEARCH_OPEN_PROPERTY_DETAILS === 'true' );

    if ( openPropertyDetails && availableWidth <= 575 ) {
        let temporaryAnchor = document.createElement( 'a' );
        temporaryAnchor.setAttribute( 'href', `/property-for-sale/${property.id}` );
        temporaryAnchor.dataset.action = 'navigate';
        temporaryAnchor.dataset.actionOpenEvents = 'twc:popup:open-property';
        temporaryAnchor.dataset.actionCloseEvents = 'twc:popup:close-property';
        temporaryAnchor.dataset.classList = 'd-none';
        document.body.appendChild( temporaryAnchor );
        temporaryAnchor.dispatchEvent( new Event( 'click', { bubbles: true } ) );
        temporaryAnchor.remove();
        return;
    }

    const onPopupClose = () => {
        ctx.propertyPopup = null;

        if ( !ctx.activeProperty ) {
            return;
        }

        ctx.activeProperty.active = false;
        ctx.activeProperty.visited = true;
        ctx.activeProperty.hover = false;

        updatePropertyIcons( ctx );
    };

    const propertyHTML = await property.getHTML();

    if ( propertyHTML instanceof Error ) {
        captureException( propertyHTML );

        ctx.root.dispatchEvent( new CustomEvent( 'twc:mapsearch:show-notification', {
            bubbles: true,
            detail: {
                msg: ctx.getTemplateString( 'genericError' ),
                options: {
                    autohide: true,
                    autohideAfter: 10000,
                },
            },
        } ) );
        return;
    }

    if ( ctx.activeProperty !== null ) {
        ctx.activeProperty.active = false;
        ctx.activeProperty.visited = true;
    }

    property.active = true;
    ctx.activeProperty = property;

    if ( !ctx.propertyPopup ) {
        ctx.propertyPopup = new mapboxgl.Popup( {
            offset: 25,
            maxWidth: 320,
            className: 'twc__map-search-propertycontainer',
            closeOnClick: false,
            closeOnMove: false,
            closeButton: true,
        } );

        ctx.propertyPopup.on( 'close', onPopupClose );

        ctx.propertyPopup.addTo( ctx.map );
    }

    ctx.propertyPopup.setHTML( propertyHTML );

    ctx.propertyPopup.setLngLat( property.position() );

    const loadContentEvent = {
        bubbles: true,
        detail: {
            container: ctx.propertyPopup.getElement(),
        },
    };

    ctx.root.dispatchEvent( new CustomEvent( 'twc:newcontentloaded', loadContentEvent ) );

    updatePropertyIcons( ctx );
};

export {
    handlePropertyLayerClick,
};
